// src/components/layout/MainLayout.tsx
import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface MainLayoutProps {
    children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    return (
        <>
            <Header />
            {/* D4 — `w-screen h-screen overflow-hidden` recortaba el contenido en
                lugar de dejarlo desplazarse, y `w-screen` (100vw) provoca scroll
                horizontal cuando hay barra vertical. Ahora el marco es una columna
                flex: `main` crece y el pie queda debajo del contenido, no encima. */}
            <main className="w-full flex-1">
                {children}
            </main>
            <Footer />
        </>
    );
};

export default MainLayout;